import React from "react";
import TextField from "@mui/material/TextField";

function CustomTextFieldAggiungi2({
    name,
    label,
    type,
    onChange,
    values,
    maxLength,
    disabled,
    index, 
}) {
    const handleChange = (e) => {
        const { value } = e.target; 
        if (onChange && typeof onChange === "function") {
            onChange(index, name, value); 
        }
    };

    return (
        <TextField
            name={name}
            label={label}
            type={type}
            inputProps={{
                maxLength: maxLength,
            }}
            variant="outlined"
            fullWidth
            disabled={disabled}
            value={values[index]?.[name] || ""} 
            onChange={handleChange} 
            sx={{
                width: "100%",
                textAlign: "left",
                borderRadius: "10px",
                backgroundColor: "#FFFFFF",
                "& .MuiOutlinedInput-root": {
                    "& fieldset": {
                        borderColor: "#fda03d",
                    },
                    "&:hover fieldset": {
                        borderColor: "#fda03d",
                    },
                    "&.Mui-focused fieldset": {
                        borderColor: "#fda03d",
                    },
                },
                "& .MuiOutlinedInput-root.Mui-disabled": {
                    bgcolor: "transparent",
                    cursor: "not-allowed",
                },
                "& .Mui-disabled": {
                    cursor: "not-allowed",
                },
                "& .MuiInputLabel-root.Mui-focused": {
                    color: "#fda03d",
                },
            }}
        />
    );
}


export default CustomTextFieldAggiungi2;
